/*FAQ*/
$(function(){
  $('.q').click(function(){
    var  qu = $(this);
    qu.next('.a').stop().slideToggle();
  });

/*scrollTop*/
  $('#pagetop').click(function(){
    $('html,body').animate({'scrollTop':0});
  });
});
